import { paymentsIframeName } from '../components/IncontextIframe';

export const fetchIframeUrl = (samlPageToken: string, targetUrl?: string) => {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = 'https://pay.instamed.com/Forms/SSO/ACS_SAML2.aspx';
    form.target = paymentsIframeName;
    document.body.appendChild(form);

    const parameters = {
        SAMLResponse: samlPageToken,
        RelayState: targetUrl,
    };

    for (const key in parameters) {
        const formField = document.createElement('input');
        formField.type = 'hidden';
        formField.name = key;
        formField.value = parameters[key];

        form.appendChild(formField);
    }

    form.submit();
    form.remove();
};
